import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { change } from 'redux-form';

import FieldError from '../../form/FieldError';

export default class Editor extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    defaultValue: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
    uid: PropTypes.string,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  componentDidMount = () => {
    const { uid, defaultValue, input } = this.props;
    const { dispatch } = this.props.meta;
    if (defaultValue) dispatch(change(uid, input.name, defaultValue));
  };

  render() {
    const {
      containerClassName,
      containerStyle,
      input,
      meta,
      wrapperClassName,
      wrapperStyle,
    } = this.props;

    const displayEditor = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <div className={containerClassName} style={containerStyle}>
          <input
            type="number"
            className={'form-control'}
            placeholder="Enter a number"
            {...input}
          />
          {meta && <FieldError meta={meta} />}
        </div>
      </div>
    );
    return displayEditor;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Number/Editor.js